<section class="valuation-header-container">
  <div class="valuation-info-header">
    <nz-skeleton
      *ngIf="!isHeaderDataReady || !data; else content"
      class="val-header-info-loader"
      [nzTitle]="true"
      [nzActive]="true"
      [nzParagraph]="false"
    ></nz-skeleton>
    <ng-template #content>
      <div class="valuation-info-header-title">
        {{ data.exchange_ticker
        }}<span
          class="valuation-info-sub-title"
          *ngIf="data.exchange_name"
          [title]="data.exchange_full_name"
          >&nbsp;({{ data.exchange_name }})</span
        >
      </div>
      <div
        class="valuation-info-header-info-item nav-info-header"
        *ngIf="callForNAV"
      >
        <div class="valuation-info-header-label">
          Prev Close:&nbsp;<span class="valuation-info-header-value">{{
            data.prev_close || "-"
          }}</span>
        </div>
        <div class="valuation-info-header-label">
          Target Price (Consensus):&nbsp;<span
            class="valuation-info-header-value"
            >{{ data.target_price_consensus || "-" }}</span
          >
        </div>
        <div class="valuation-info-header-label">
          P/NAV:&nbsp;<span class="valuation-info-header-value">{{
            data.p_nav || "-"
          }}</span>
        </div>
        <div class="valuation-info-header-label">
          Shares:&nbsp;<span class="valuation-info-header-value">{{
            data.share || "-"
          }}</span>
        </div>
      </div>
      <div class="valuation-info-header-info-item" *ngIf="!callForNAV">
        <div class="valuation-info-header-label">
          Prev Close:&nbsp;<span class="valuation-info-header-value">{{
            data.prev_close || "-"
          }}</span>
        </div>
        <div class="valuation-info-header-label">
          Market Cap:&nbsp;<span class="valuation-info-header-value">{{
            data.mcap || "-"
          }}</span>
        </div>
        <div class="valuation-info-header-label">
          Enterprise Value:&nbsp;<span class="valuation-info-header-value">{{
            data.ev || "-"
          }}</span>
        </div>
      </div>
      <div class="valuation-info-header-label">
        Date:&nbsp;<span class="valuation-info-header-value">{{
          data.last_date || "-"
        }}</span>
      </div>
    </ng-template>
  </div>
  <div *ngIf="showGlobalSettingsButton" class="valuation-header-right-section">
    <app-global-user-settings-button></app-global-user-settings-button>
  </div>
</section>
